import { getLogger } from '@trimble/logging';
import { POINT_CLOUD_STYLING_DEFAULTS } from '@trimble/types';

export const POINT_BUDGET_MIN = 800_000;
export const POINT_BUDGET_MAX = 30_000_000;
export const POINT_BUDGET_STEP = 100_000;
export const DEFAULT_POINT_BUDGET =
  POINT_CLOUD_STYLING_DEFAULTS.point?.budget ?? POINT_BUDGET_MIN;

export function isValidPointBudget(value: unknown): value is number {
  return (
    typeof value === 'number' &&
    Number.isFinite(value) &&
    value >= POINT_BUDGET_MIN &&
    value <= POINT_BUDGET_MAX
  );
}

export function parsePointBudget(value: string): number | undefined {
  try {
    const parsed: unknown = JSON.parse(value);
    return isValidPointBudget(parsed) ? parsed : undefined;
  } catch (error) {
    getLogger().warn('Ignoring a stored point budget that is not JSON', error);
    return undefined;
  }
}
